import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useCompanyStore = defineStore('companies:company', () => {
  // state
  const company = ref({})

  // getters
  const getCompanyId = computed(() => company.value?.id || null)
  const getCompanyName = computed(() => company.value?.name || null)

  // actions
  function resetCompany () {
    company.value = {}
  }

  function setCompany (data) {
    company.value = data
  }

  return {
    // state
    company,

    // getters
    getCompanyId,
    getCompanyName,

    // actions
    resetCompany,
    setCompany,
  }
})
